import * as React from 'react';
import {connect} from 'react-redux';

const RadioChecked = (props: any) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill={props?.globalStyles?.primaryColor}
    stroke={props?.globalStyles?.primaryColor}
    stroke-width="0.00024000000000000003"
    {...props}>
    <g data-name="Layer 2">
      <g data-name="radio-button-on">
        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" />
        <path d="M12 7a5 5 0 1 0 5 5 5 5 0 0 0-5-5z" />
      </g>
    </g>
  </svg>
);

const mapStateToProps = ({globalStyles}: any) => ({
  globalStyles: globalStyles.value,
});

export default connect(mapStateToProps)(RadioChecked);
